import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axiosInstance from 'src/services/common/axiosInstance'
import { API_ROUTES } from 'src/services/common/routes'

export const fetchDetailGacha = createAsyncThunk(
  'data/fetchDetailGacha',
  async (id, { rejectWithValue }) => {
    try {
      if (!id) return {}
      const response = await axiosInstance.get(API_ROUTES.GachasId.replace(':id', id))
      return response.data.items
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message)
    }
  }
)

export const getDetailGacha = createSlice({
  name: 'getDetailGacha',
  initialState: {
    gacha: {},
    isLoading: false,
    errorMessage: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDetailGacha.pending, (state) => {
        state.isLoading = true
        state.errorMessage = null
      })

      .addCase(fetchDetailGacha.fulfilled, (state, action) => {
        state.isLoading = false
        state.gacha = action.payload || {}
      })

      .addCase(fetchDetailGacha.rejected, (state, action) => {
        state.isLoading = false
        state.errorMessage = action.payload || action.error?.message
      })
  }
})

export default getDetailGacha.reducer
